export const getGreeting = () => {
  const today = new Date()
  const curHr = today.getHours()

  if (curHr < 12) {
    return 'Goedemorgen'
  } else if (curHr < 18) {
    return 'Goedemiddag'
  } else {
    return 'Goedenavond'
  }
}
